<template>
  <section class="wxEdit">
    <el-dialog title="修改手机号" :visible.sync="dialogVisible" width="750px" :before-close="ai_dialog_close">
      <div class="wxEdit-content">
        <el-form
          ref="info"
          :model="inform"
          :rules="rules"
          status-icon
          label-position="left"
          label-width="100px"
        >
          <el-form-item prop="phone" label="原手机号：">
            <el-input
              v-model="inform.phone"
              type="text"
              auto-complete="off"
              placeholder="请输入原手机号"
              clearable
            />
          </el-form-item>
          <el-form-item class="sms" label="图形验证码：" required>
            <div class="formItemBox">
              <el-input
                v-model="info1.captcha"
                class="photoYz"
                type="smsCheck"
                auto-complete="off"
                placeholder="请输入验证码"
                clearable
              />
              <el-button type="text" class="photoSms sms1">
                <img :src="imgUrl" alt="" @click="handleCheckImg">
              </el-button>
            </div>
          </el-form-item>
          <el-form-item prop="code" label="验证码：" class="sms">
            <div class="formItemBox">
              <el-input
                v-model="inform.code"
                class="numYz"
                auto-complete="off"
                placeholder="请输入验证码"
                clearable
                type="smsCheck"
              />
              <el-button
                :disabled="inform.phone.length != 11 || isSendCode"
                class="photoSms"
                @click="getVerificationCode"
              >
                {{ codeText }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item prop="phone1" label="新手机号：">
            <el-input
              v-model="inform.phone1"
              type="text"
              auto-complete="off"
              placeholder="请输入新手机号"
              clearable
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmit1">取 消</el-button>
        <el-button type="primary" @click="handleSubmit1">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import api from '@/api/app'

const chinaMobileRegex = /^1\d{10}$/
export default {
  name: 'ComPhoneEdit',
  components: {},
  props: {
    value: Boolean,
    id: Number
    // rules: {
    //   type: Object,
    //   default: () => {
    //     return {}
    //   }
    // }
  },
  data() {
    return {
      imgUrl: null,
      isSendCode: false,
      codeText: '发送验证码',
      dialogVisible: false,
      loading: false,
      mineInfo: mock.mine.set.viewInfo,
      mineInit: mock.mine.set.init,
      inform: {
        phone: '',
        code: '',
        phone1: ''
      },
      info1: {
        phone: null,
        captcha: null,
        key: null
      },
      rules: {
        phone: [
          {
            required: true, message: '请输入原手机号', trigger: 'blur'
          },
          {
            pattern: chinaMobileRegex,
            message: '手机格式不正确,目前只支持中国大陆的手机号码',
            trigger: 'blur'
          }
        ],
        captcha: [
          {
            required: true, message: '请输入图片验证码', trigger: 'blur'
          }
        ],
        code: [
          {
            required: true, message: '请输入验证码', trigger: 'blur'
          }
        ],
        phone1: [
          {
            required: true, message: '请输入新手机号', trigger: 'blur'
          },
          {
            pattern: chinaMobileRegex,
            message: '手机格式不正确,目前只支持中国大陆的手机号码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val
      }
    }
  },
  mounted() {
    this.loading = true
    this.handleCheckImg()
  },
  methods: {
    async handleCheckImg() {
      const obj = await this.mineInit.handleCheckImg()
      this.imgUrl = obj.img
      this.info1.key = obj.key
    },
    getVerificationCode() {
      this.info1.phone = this.inform.phone
      if (this.info1.captcha) {
        api.system.sendSms(this.info1).then(() => {
          this.$message({
            message: '验证码已发送',
            type: 'success'
          })
          this.countDown(60)
        }).catch(() => {
          this.handleCheckImg()
        })
      } else {
        this.$message({
          message: '请正确填写图片验证码',
          type: 'error'
        })
      }
    },
    countDown(time) {
      if (time === 0) {
        this.isSendCode = false
        this.codeText = '发送验证码'
        return
      } else {
        this.isSendCode = true
        this.codeText = '重新发送(' + time + ')'
        time--
      }
      setTimeout(() => {
        this.countDown(time)
      }, 1000)
    },
    handleSubmit1() {
      this.$refs.info.validate((valid) => {
        if (valid) {
          api.mine.update.wx(this.inform).then((res) => {
            this.$message.success('修改成功')
            this.inform.phone1 = this.inform.phone
            this.cancelSubmit1()
          })
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    cancelSubmit1() {
      this.dialogVisible = false
      this.$emit('input', false)
    },
    ai_dialog_close() {
      this.cancelSubmit1()
    }
  }
}
</script>

<style lang="scss" scoped >
.wxEdit {
  &-content {
    height: 100%;
    text-align: center;
  }
}
.photoYz{
  width: 72%;
}
.numYz{
  width: 71.2%;
}
.formItemBox{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>

